export enum EventType {
  DAO_LINK_CREATE = "DAO_LINK_CREATE",
  DAO_LINK_DELETE = "DAO_LINK_DELETE",
  REQUEST_DAO_CHANGE = "REQUEST_DAO_CHANGE",
  REQUEST_DAO_CREATE = "REQUEST_DAO_CREATE",
  CONFORMITY_INFO = "CONFORMITY_INFO",
  INDEXING_FINISHED = "INDEXING_FINISHED",
  PACKAGE = "PACKAGE",
  INSTITUTION_CHANGE = "INSTITUTION_CHANGE",
  EXTERNAL_SYSTEM_CREATE = "EXTERNAL_SYSTEM_CREATE",
  EXTERNAL_SYSTEM_UPDATE = "EXTERNAL_SYSTEM_UPDATE",
  EXTERNAL_SYSTEM_DELETE = "EXTERNAL_SYSTEM_DELETE",
  NODES_CHANGE = "NODES_CHANGE",
  OUTPUT_ITEM_CHANGE = "OUTPUT_ITEM_CHANGE",
  FILES_CHANGE = "FILES_CHANGE",
  BULK_ACTION_STATE_CHANGE = "BULK_ACTION_STATE_CHANGE",
  DELETE_LEVEL = "DELETE_LEVEL",
  ADD_LEVEL_AFTER = "ADD_LEVEL_AFTER",
  ADD_LEVEL_BEFORE = "ADD_LEVEL_BEFORE",
  ADD_LEVEL_UNDER = "ADD_LEVEL_UNDER",
  APPROVE_VERSION = "APPROVE_VERSION",
  MOVE_LEVEL_AFTER = "MOVE_LEVEL_AFTER",
  MOVE_LEVEL_BEFORE = "MOVE_LEVEL_BEFORE",
  MOVE_LEVEL_UNDER = "MOVE_LEVEL_UNDER",
  RECORD_UPDATE = "RECORD_UPDATE",
  FUND_UPDATE = "FUND_UPDATE",
  FUND_CREATE = "FUND_CREATE",
  FUND_RECORD_CHANGE = "FUND_RECORD_CHANGE",
  VISIBLE_POLICY_CHANGE = "VISIBLE_POLICY_CHANGE",
  FUND_DELETE = "FUND_DELETE",
  OUTPUT_STATE_CHANGE = "OUTPUT_STATE_CHANGE",
  OUTPUT_CHANGES = "OUTPUT_CHANGES",
  FUND_INVALID = "FUND_INVALID",
  OUTPUT_CHANGES_DETAIL = "OUTPUT_CHANGES_DETAIL",
  USER_CREATE = "USER_CREATE",
  USER_CHANGE = "USER_CHANGE",
  GROUP_CREATE = "GROUP_CREATE",
  GROUP_CHANGE = "GROUP_CHANGE",
  GROUP_DELETE = "GROUP_DELETE",
  REQUEST_CREATE = "REQUEST_CREATE",
  REQUEST_CHANGE = "REQUEST_CHANGE",
  REQUEST_DELETE = "REQUEST_DELETE",
  REQUEST_ITEM_QUEUE_CREATE = "REQUEST_ITEM_QUEUE_CREATE",
  REQUEST_ITEM_QUEUE_DELETE = "REQUEST_ITEM_QUEUE_DELETE",
  REQUEST_ITEM_QUEUE_CHANGE = "REQUEST_ITEM_QUEUE_CHANGE",
  DELETE_NODES = "DELETE_NODES",
  FUND_EXTENSION_CHANGE = "FUND_EXTENSION_CHANGE",
  STRUCTURE_DATA_CHANGE = "STRUCTURE_DATA_CHANGE",
  ACCESS_POINT_UPDATE = "ACCESS_POINT_UPDATE",
  ACCESS_POINT_EXPORT_NEW = "ACCESS_POINT_EXPORT_NEW",
  ACCESS_POINT_EXPORT_STARTED = "ACCESS_POINT_EXPORT_STARTED",
  ACCESS_POINT_EXPORT_COMPLETED = "ACCESS_POINT_EXPORT_COMPLETED",
  ACCESS_POINT_EXPORT_FAILED = "ACCESS_POINT_EXPORT_FAILED",
  ISSUE_LIST_UPDATE = "ISSUE_LIST_UPDATE",
  ISSUE_LIST_CREATE = "ISSUE_LIST_CREATE",
  ISSUE_UPDATE = "ISSUE_UPDATE",
  ISSUE_CREATE = "ISSUE_CREATE",
}
